import { Box, Stack, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import SimpleBar from "simplebar-react"
import _ from "lodash"
import { useEffect, useRef } from "react"

export const HorizontalScrollPane = ({
  children,
  sx = {},
  simpleBarProps = {},
  stackProps = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = _.get(
    theme,
    "components.HorizontalScrollPane.styleOverrides",
    {}
  )
  const { root, listWrapper } = styleOverrides
  const wrapperRef = useRef(null)

  //allow mouse user to scroll horizontal by using mouse wheel
  useEffect(() => {
    const scroller = wrapperRef.current?.querySelector(
      ".simplebar-content-wrapper"
    )
    if (!scroller) return
    const handleWheel = (e) => {
      //return if user already scrolls horizontally (using trackpad or mobile touch)
      const isHorizontalScroll = Math.abs(e.deltaX) > 0
      if (isHorizontalScroll) return
      e.preventDefault()
      scroller.scrollLeft += e.deltaY
    }

    scroller.addEventListener("wheel", handleWheel, { passive: false })

    return () => {
      scroller.removeEventListener("wheel", handleWheel)
    }
  }, [])

  return (
    <Box
      className="horizontalScrollPane-root"
      ref={wrapperRef}
      sx={deepmerge(root, sx)}
      {...props}
    >
      <SimpleBar {...simpleBarProps}>
        <Stack
          className="horizontalScrollPane-list"
          direction="row"
          {...stackProps}
          sx={deepmerge(listWrapper, stackProps.sx || {})}
        >
          {children}
        </Stack>
      </SimpleBar>
    </Box>
  )
}
